function EventMoviePollController(containerObject){
	/* THIS FIX */
	var _this = this;
	
	/* PRIVATE CONSTANTS */
	
	
	/* PRIVATE VARIABLES */
	

	/* PUBLIC PROPERTIES */
	this.container = null;
	this.inited = false;
	
	
	/* PRIVATE FUNCTIONS */
	function _construct(){
		_this.container = containerObject;
		_this.init();
	}	

	
	/* PUBLIC FUNCTIONS */	
	this.init = function(){
		if(!_this.inited){	
			
			// object references
			
			// init
			var form = new EventMoviePollForm($('#event-movie-poll-form-container'));
			
			_this.inited = true;
		}
	};
	

	/* INIT CONSTRUCTOR */
	_construct();
}


/* PUBLIC CONSTANTS */
